import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { PENCIL,LOGOUT_ICON } from "../../Constants/SrcImages";
import { EXPAN_ROW_COLUMNS_ACYCLE,COLUMNS_CYCLES_AREA } from "../../Constants/DatatableColumns";
import { Row, Col, Container, Button, Label } from "reactstrap";
import { ModalACycle } from "./../../Constants/Modal";
import {validateTokenStorage} from './../../Constants/Util';
import { getACycle, getCycles, postACycle, putACycles ,deleteACycle} from "../../Constants/Services";
import { ICycles,IACycles } from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IACycleState {
  dataCycle: ICycles[];
  formCycleSelected:{
      cy_id:string,
      cy_desc:string
  };
  dataACycle: IACycles[];
  formDataACycle: IACycles;
  msg_error: string;
  loadingCycle: boolean;
  loadingArea: boolean;
  isOpenAddAreaModel:boolean;
  isOpenEditAreaModel:boolean;
}

class Acycles extends Component<RouteComponentProps<{}>, IACycleState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataACycle: [],
      dataCycle: [],
      formDataACycle: {
        ar_id:"",
        ar_cycle:"",
        ar_desc:"",
        ar_sort:"",
        ar_status:"",
        ar_literal:"0"
      },
      formCycleSelected:{
        cy_id:"",
        cy_desc:""
    },
      msg_error: "",
      loadingCycle: false,
      loadingArea: false,
      isOpenAddAreaModel:false,
      isOpenEditAreaModel:false
    };

    this.fetCycles = this.fetCycles.bind(this);
    this.fetArea = this.fetArea.bind(this);
    this.handlerPutACycles = this.handlerPutACycles.bind(this);
    this.handlerPostACycles = this.handlerPostACycles.bind(this);
    this.onChangeACycles = this.onChangeACycles.bind(this);
    this.rechargeDataCycle = this.rechargeDataCycle.bind(this);
    this.rechargeDataArea = this.rechargeDataArea.bind(this);
    this.addAreaModel = this.addAreaModel.bind(this);
    this.editAreaModel = this.editAreaModel.bind(this);
    this.setOrden = this.setOrden.bind(this);
    this.handleModalEditArea = this.handleModalEditArea.bind(this);
    this.columnsEditArea = this.columnsEditArea.bind(this);
    this.setDigitoType = this.setDigitoType.bind(this);
  }

  async fetCycles() {
    const response = await getCycles();
    this.setState({
      dataCycle: response,
      loadingCycle:false,
      msg_error:""
    });
  }

  async fetArea({cy_id,cy_desc}) {
    const response = await getACycle(cy_id);
    this.setState({
      dataACycle: response,
      formCycleSelected:{
          cy_id,
          cy_desc
      },
      loadingArea:false,
      msg_error:""

    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetCycles();
  }

  handlerPostACycles() {
    const props = this.state.formDataACycle;
    const propsCycle = this.state.formCycleSelected;
    const body = {
      ar_cycle: propsCycle.cy_id,
      ar_desc: props.ar_desc,
      ar_sort:props.ar_sort,
      ar_literal:props.ar_literal
    };
  
    if (propsCycle.cy_id.length > 0 && props.ar_desc.length>0 && props.ar_sort.length>0) {
      postACycle(body);
      this.setState({ loadingArea: true,loadingCycle:false, msg_error: "",isOpenEditAreaModel:false,isOpenAddAreaModel:false });
      setTimeout(() => {
        this.fetArea({cy_id:propsCycle.cy_id,cy_desc:propsCycle.cy_desc});
      }, 1000);
    } else {
      this.setState({ msg_error: "Algunos campos estan vaciossss" });
    }
  }

  handlerPutACycles() {
    const props = this.state.formDataACycle;
    const propsCycle = this.state.formCycleSelected;
    const body = {
        ar_id:props.ar_id, 
        ar_desc: props.ar_desc,
        ar_sort:props.ar_sort,
        ar_literal:props.ar_literal
    };

    if (props.ar_desc.length>0 && props.ar_sort.length>0) {
      putACycles(body);
      this.setState({ loadingArea: true,loadingCycle:false, msg_error: "",isOpenEditAreaModel:false,isOpenAddAreaModel:false });
      setTimeout(() => {
        this.fetArea({cy_id:propsCycle.cy_id,cy_desc:propsCycle.cy_desc});
      }, 1000);
    }
    else{
      this.setState({ msg_error: "Algunos campos estan vacios" });
    }
  }

  handlerDeleteACycle(ar_id: string) {
    const propsCycle = this.state.formCycleSelected;
    const body = {
      ar_id,
    };
    deleteACycle(body);

    this.setState({ loadingArea: true,msg_error:"" });
    setTimeout(() => {
      this.fetArea({cy_id:propsCycle.cy_id,cy_desc:propsCycle.cy_desc});
    }, 1000);
  }

  onChangeACycles(e: any) {
    this.setState({
      formDataACycle: {
        ...this.state.formDataACycle,
        [e.target.name]: e.target.value,
      },
      msg_error:""
    });
  }

  rechargeDataCycle() {
    this.setState({ loadingCycle: true,loadingArea:false });
    setTimeout(() => {
      this.fetCycles();
    }, 1000);
  }

  rechargeDataArea() {
    const propsCycle = this.state.formCycleSelected;
    this.setState({ loadingArea: true,loadingCycle:false });
    setTimeout(() => {
      this.fetArea({cy_id:propsCycle.cy_id,cy_desc:propsCycle.cy_desc});
    }, 1000);
  }

  addAreaModel() {
    this.setState((prevState) => ({
      isOpenAddAreaModel: !prevState.isOpenAddAreaModel,
      formDataACycle:{
        ar_id:"",
        ar_cycle:"",
        ar_desc:"",
        ar_sort:"",
        ar_status:"",
        ar_literal:"0"
      }
    }));
  }

  editAreaModel() {
    this.setState((prevState) => ({
      isOpenEditAreaModel: !prevState.isOpenEditAreaModel,
      formDataACycle:{
        ar_id:"",
        ar_cycle:"",
        ar_desc:"",
        ar_sort:"",
        ar_status:"",
        ar_literal:"0"
      }
    }));
  }

  setOrden = ({ ar_sort}: any) => {
    this.setState({
      formDataACycle: {
        ...this.state.formDataACycle,
        ar_sort
      },
    });
  };

  setDigitoType = (ar_literal) => {
    this.setState({
      formDataACycle: {
        ...this.state.formDataACycle,
        ar_literal
      },
    });
  };

  handleModalEditArea(row: any) {
    this.setState((prevState) => ({
      isOpenEditAreaModel: !prevState.isOpenEditAreaModel,
      formDataACycle: row,
      msg_error:""
    }));
  }

  columnsEditArea = (cell: any, row: any) => (
    <React.Fragment>
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handleModalEditArea(row)}>
            {row.ar_id}
          </Label>
          <img className="img-status img-search" onClick={() => this.handleModalEditArea(row)} src={PENCIL} alt="" />
          <img className="img-pencil ml-3" onClick={() => this.handlerDeleteACycle(row.ar_id)} src={LOGOUT_ICON} alt="" />
        </Col>
      </Row>
    </React.Fragment>
  );

  render() {
    const props = this.state;
    var dataOrderArray=[];
        for (var i = 1; i < 32; i++) {
                dataOrderArray.push({ ar_id:i,ar_sort:i.toString()})
        }
    return (
      <React.Fragment>
        {props.isOpenAddAreaModel && (
          <ModalACycle
          title ="Agregar nueva area"
            onChangeData ={this.onChangeACycles}
            isOpen ={props.isOpenAddAreaModel}
            toggle={this.addAreaModel}
            toggleSave={this.handlerPostACycles}
            setOrden ={this.setOrden}
            dataOrden ={dataOrderArray}
             dataFACycle={props.formDataACycle}
            msg_error={props.msg_error}
            setDigitoType ={this.setDigitoType}
          />
        )}

{props.isOpenEditAreaModel && (
          <ModalACycle
          title ="Editar area"
            onChangeData ={this.onChangeACycles}
            isOpen ={props.isOpenEditAreaModel}
            toggle={this.editAreaModel}
            toggleSave={this.handlerPutACycles}
            setOrden ={this.setOrden}
            dataOrden ={dataOrderArray}
             dataFACycle={props.formDataACycle}
            msg_error={props.msg_error}
            setDigitoType ={this.setDigitoType}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row>
                <Col sm={12} className="text-center">
                  <h3>Areas por ciclo</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loadingCycle} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeDataCycle()}>
                    Recargar
                  </Button>
                </Col>
                <Col sm={12}>
                <DatatableExpand
                    data={props.dataCycle}
                    columns={COLUMNS_CYCLES_AREA()}
                    keyProp="cy_id"
                    expandRow={EXPAN_ROW_COLUMNS_ACYCLE(
                      this.fetArea,
                      props.dataACycle,
                      this.addAreaModel,
                      this.rechargeDataArea,
                      props.loadingArea,
                      this.columnsEditArea
                    )}
                    exportD={false}
                    searchs={false}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Acycles;